import request from '@/utils/request';
import * as types from '@/api/cla/types';
// 签署CLA
export function signCla(data: types.signClaReqType): Promise<any> {
  return request({
    url: `/api/v2/cla/sign/add`,
    method: 'post',
    data
  });
}
// 签署CLA详情
export function getClaInfo(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/sign/info`,
    method: 'get',
    params
  }, {
    customError: true
  });
}
// 本人已签署CLA详情
export function getClaInfoDetail(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/sign/detail`,
    method: 'get',
    params
  }, {
    customError: true
  });
}
// 获取组织里面用户已签署CLA详情
export function getGroupClaInfoDetail(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/${params.group_id}/detail`,
    method: 'get',
    params
  }, {
    customError: true
  });
}
// 组织下的cla列表
export function getGroupClaList(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/${params.group_id}/list`,
    method: 'get',
    params
  });
}
// 组织下的cla列表
export function setGroupClaStatus(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/${params.group_id}/status`,
    method: 'put',
    params
  });
}
// 组织下的cla列表
export function deleteGroupCla(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/${params.group_id}/del`,
    method: 'delete',
    params
  });
}
// 已签署CLA协议的用户列表
export function getClaUsers(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/${params.group_id}/signUsers`,
    method: 'get',
    params: params.params
  });
}
// CLA协议历史版本列表
export function getClaVersion(params: types.paramsObj): Promise<any> {
  return request({
    url: `/api/v2/cla/getClaHistory`,
    method: 'get',
    params
  });
}
